module.exports = __webpack_public_path__ + "media/images/icon__compete@3x-48ec956a098a109a48ca98ebec98f580.png";